export default __webpack_public_path__ + "static/media/this-site.f10b0030.jpg";